import { createFileRoute } from "@tanstack/react-router";
import { RentownoscFormPage } from "@/features/sys-premiowy/rentownosc-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/rentownosc/nowa")({
	component: RentownoscFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-rentownosc",
			location.pathname,
		);
	},
});
